import { vm } from '@/main'
import { Dispatcher } from '@/APIDispatcher'

export const AccountsApi = {

  listAccounts (cid) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('accounts/list', { company_id: cid }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s)
        } else {
          reject(new Error(s.errorCode))
        }
      })
    })
  },

  accountDetails (accountId) {
    return new Promise((resolve, reject) => {
      Dispatcher.post('account/details', { id: accountId }).then(s => {
        if (Dispatcher.success(s)) {
          resolve(s.details)
        } else {
          reject(new Error(s.errorCode))
        }
      })
    })
  },
  accountSet (account) {
    if (account.id) {
      return new Promise((resolve, reject) => {
        Dispatcher.post('account/update', { details: account }).then(s => {
          if(Dispatcher.success(s)) {
            resolve(s)
          } else {
            reject(new Error(s.errorCode))
          }
        })
      })
    } else {
      //create new account
      return new Promise((resolve, reject) => {
        Dispatcher.post('accounts/create', { details: account }).then(s => {
          if(Dispatcher.success(s)) {
            resolve(s)
          } else {
            reject(new Error(s.errorCode))
          }
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/accounts/api.js